import React from 'react'
import styles from './TextOption.module.css'

const TextOption = ({ name, value, handleSelection }) => {
    return (
        <div className={styles.selectContainer}>
            <label className={styles.container}> <span className={styles.item}>{value}</span>
                <input 
                type="radio" 
                name={name}
                value={value}
                onChange={handleSelection}
                
                />
                <span className={styles.checkmark} />
            </label>
        </div>

    )
}

export default TextOption
